import React, { useState } from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { MenuOutlined } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { colors } from "../../theme/theme";
import {
  clearUserData,
  setAuthenticationState,
} from "../../redux/dispatchers/users.dispatcher";

const navItems = [
  { id: 1, title: "Posts", route: "/admin/posts" },
  { id: 2, title: "Gallery", route: "/admin/gallery" },
  { id: 3, title: "Documents", route: "/admin/documents" },
  { id: 4, title: "About Me", route: "/admin/about-me" },
];

const AdminHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = useSelector((state) => state.user);

  const smScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [profileAnchor, setProfileAnchor] = useState(null);
  const [navAnchor, setNavAnchor] = useState(null);

  const isActive = (route) => location.pathname.startsWith(route);

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1200,
        backgroundColor: "#000",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        px: { xs: 2, md: 4 },
        py: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.5}
        sx={{ cursor: "pointer" }}
        onClick={() => navigate("/admin/posts")}
      >
        <img
          src={require("../../assets/icons/logo_sm.png")}
          alt="logo"
          style={{ height: "32px" }}
        />
        <Typography
          sx={{
            color: "#fff",
            fontFamily: "Mulish-Bold",
            fontSize: "16px",
            display: { xs: "none", sm: "block" },
          }}
        >
          Admin
        </Typography>
      </Stack>

      {!smScreen && (
        <Stack direction="row" spacing={4}>
          {navItems.map((item) => (
            <Box
              key={item.id}
              onClick={() => navigate(item.route)}
              sx={{
                cursor: "pointer",
                pb: 0.5,
                borderBottom: isActive(item.route)
                  ? `2px solid ${colors.secondary}`
                  : "2px solid transparent",
              }}
            >
              <Typography
                sx={{
                  color: isActive(item.route) ? "#fff" : "rgba(255,255,255,0.6)",
                  fontFamily: isActive(item.route)
                    ? "Mulish-SemiBold"
                    : "Mulish-Regular",
                  fontSize: "15px",
                  "&:hover": { color: "#fff" },
                }}
              >
                {item.title}
              </Typography>
            </Box>
          ))}
        </Stack>
      )}

      <Stack direction="row" alignItems="center" spacing={1.5}>
        {smScreen && (
          <IconButton onClick={(e) => setNavAnchor(e.currentTarget)}>
            <MenuOutlined sx={{ color: "#fff" }} />
          </IconButton>
        )}
        <Menu
          anchorEl={navAnchor}
          open={Boolean(navAnchor)}
          onClose={() => setNavAnchor(null)}
        >
          {navItems.map((item) => (
            <MenuItem
              key={item.id}
              selected={isActive(item.route)}
              onClick={() => {
                navigate(item.route);
                setNavAnchor(null);
              }}
              sx={{ fontFamily: "Mulish-SemiBold", fontSize: "14px" }}
            >
              {item.title}
            </MenuItem>
          ))}
        </Menu>

        <Box
          component="img"
          src={userData?.avatar || require("../../assets/images/default.jpg")}
          alt="avatar"
          onClick={(e) => setProfileAnchor(e.currentTarget)}
          sx={{
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            cursor: "pointer",
            border: `1px solid ${colors.secondary}`,
          }}
        />
        <Menu
          anchorEl={profileAnchor}
          open={Boolean(profileAnchor)}
          onClose={() => setProfileAnchor(null)}
        >
          <MenuItem
            onClick={() => {
              dispatch(setAuthenticationState(false));
              dispatch(clearUserData());
            }}
            sx={{ fontFamily: "Mulish-SemiBold", fontSize: "14px" }}
          >
            Logout
          </MenuItem>
        </Menu>
      </Stack>
    </Box>
  );
};

export default AdminHeader;
